import { Duration, Mapper, Mappers } from 'cloverleaf-client';
import { mapperManager } from 'mrugames-state-awareness';

export const Note_DEFAULT_VALUE: Note = {
    thisInstanceType: 'Note',
    created: new Date(),
    createdBy: 0,
    draft: '',
    id: '',
    modified: new Date(),
    modifiedBy: 0,
    text: '',
    version: 0,
};

export const PublicNote_DEFAULT_VALUE: PublicNote = {
    thisInstanceType: 'PublicNote',
    created: new Date(),
    createdBy: 0,
    id: '',
    modified: new Date(),
    modifiedBy: 0,
    text: '',
};

export const Note_CONSTRAINTS = {
    created: {

    },
    createdBy: {

    },
    draft: {

    },
    id: {

    },
    modified: {

    },
    modifiedBy: {

    },
    text: {

    },
    version: {

    },
};

export const PublicNote_CONSTRAINTS = {
    created: {

    },
    createdBy: {

    },
    id: {

    },
    modified: {

    },
    modifiedBy: {

    },
    text: {

    },
};

export const Note_MAPPER: Mapper<Note> = (payload, reversed) => ({
    thisInstanceType: mapperManager.callSuperMapper(payload ? payload.thisInstanceType : payload, Mappers.identityMapper, reversed),
    created: mapperManager.callSuperMapper(payload ? payload.created : payload, Mappers.dateMapper, reversed),
    createdBy: mapperManager.callSuperMapper(payload ? payload.createdBy : payload, Mappers.identityMapper, reversed),
    draft: mapperManager.callSuperMapper(payload ? payload.draft : payload, Mappers.identityMapper, reversed),
    id: mapperManager.callSuperMapper(payload ? payload.id : payload, Mappers.identityMapper, reversed),
    modified: mapperManager.callSuperMapper(payload ? payload.modified : payload, Mappers.dateMapper, reversed),
    modifiedBy: mapperManager.callSuperMapper(payload ? payload.modifiedBy : payload, Mappers.identityMapper, reversed),
    text: mapperManager.callSuperMapper(payload ? payload.text : payload, Mappers.identityMapper, reversed),
    version: mapperManager.callSuperMapper(payload ? payload.version : payload, Mappers.identityMapper, reversed)
});

mapperManager.registerMapper('Note', Note_MAPPER);

export const PublicNote_MAPPER: Mapper<PublicNote> = (payload, reversed) => ({
    thisInstanceType: mapperManager.callSuperMapper(payload ? payload.thisInstanceType : payload, Mappers.identityMapper, reversed),
    created: mapperManager.callSuperMapper(payload ? payload.created : payload, Mappers.dateMapper, reversed),
    createdBy: mapperManager.callSuperMapper(payload ? payload.createdBy : payload, Mappers.identityMapper, reversed),
    id: mapperManager.callSuperMapper(payload ? payload.id : payload, Mappers.identityMapper, reversed),
    modified: mapperManager.callSuperMapper(payload ? payload.modified : payload, Mappers.dateMapper, reversed),
    modifiedBy: mapperManager.callSuperMapper(payload ? payload.modifiedBy : payload, Mappers.identityMapper, reversed),
    text: mapperManager.callSuperMapper(payload ? payload.text : payload, Mappers.identityMapper, reversed)
});

mapperManager.registerMapper('PublicNote', PublicNote_MAPPER);

export interface Note {
    thisInstanceType?: string;
    created: Date;
    createdBy: number;
    draft: string;
    id: string;
    modified: Date;
    modifiedBy: number;
    text: string;
    version: number;
}

export interface PublicNote {
    thisInstanceType?: string;
    created: Date;
    createdBy: number;
    id: string;
    modified: Date;
    modifiedBy: number;
    text: string;
}
